import { render, staticRenderFns } from "./VisitStatisticsCategory.vue?vue&type=template&id=f8b8003c&scoped=true"
import script from "./VisitStatisticsCategory.vue?vue&type=script&lang=js"
export * from "./VisitStatisticsCategory.vue?vue&type=script&lang=js"
import style0 from "./VisitStatisticsCategory.vue?vue&type=style&index=0&id=f8b8003c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b8003c",
  null
  
)

export default component.exports